/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface MessageCounterContextType {
  unreadCount: number;
  incrementUnreadCount: () => void;
  resetUnreadCount: () => void;
  setUnreadCount: (count: number) => void;
  pluvialAlertsCount: number;
  setPluvialAlertsCount: (count: number) => void;
  resetPluvialAlertsCount: () => void;
}

const MessageCounterContext = createContext<MessageCounterContextType | undefined>(undefined);

interface MessageCounterProviderProps {
  children: ReactNode;
}

export const MessageCounterProvider: React.FC<MessageCounterProviderProps> = ({ children }) => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [pluvialAlertsCount, setPluvialAlertsCount] = useState(0);

  const incrementUnreadCount = useCallback(() => {
    setUnreadCount(prev => prev + 1);
  }, []);

  const resetUnreadCount = useCallback(() => {
    setUnreadCount(0);
  }, []);

  const handleSetUnreadCount = useCallback((count: number) => {
    setUnreadCount(count);
  }, []);

  const handleSetPluvialAlertsCount = useCallback((count: number) => {
    setPluvialAlertsCount(count);
  }, []);

  const resetPluvialAlertsCount = useCallback(() => {
    setPluvialAlertsCount(0);
  }, []);

  const value: MessageCounterContextType = {
    unreadCount,
    incrementUnreadCount,
    resetUnreadCount,
    setUnreadCount: handleSetUnreadCount,
    pluvialAlertsCount,
    setPluvialAlertsCount: handleSetPluvialAlertsCount,
    resetPluvialAlertsCount,
  };

  return (
    <MessageCounterContext.Provider value={value}>
      {children}
    </MessageCounterContext.Provider>
  );
};

export const useMessageCounter = (): MessageCounterContextType => {
  const context = useContext(MessageCounterContext);
  if (context === undefined) {
    throw new Error('useMessageCounter debe ser usado dentro de un MessageCounterProvider');
  }
  return context;
};
